/**
 * A wrapper for "JSON.parse()" to support "undefined" value
 * @example
 * const result = safeJsonParse<T>(jsonString) ?? fallback
 */
export const safeJsonParse = (value) => {
    if (value === null || value === undefined || value === "") {
        return undefined;
    }
    if (value === "undefined" || value === "null") {
        return undefined;
    }
    try {
        return JSON.parse(value);
    } catch {
        return undefined;
    }
};
